// FE-SCRM-011 — REST client for the Opportunity detail surface.
//
// Three endpoints touched here:
// * ``GET /api/v1/sales/opportunities/{id}`` — detail payload incl.
//   ``stakeholder_risks``.
// * ``GET /api/v1/sales/activities?opportunity_id={id}`` — the
//   activity timeline shown on the page.
// * ``POST /api/v1/sales/opportunities/{id}/generate-bor-letter`` —
//   triggers PDF generation, returns the signed-download URL plus
//   the new ``bor_letter_generated`` activity id.

import { api } from "@/api/client";

import type {
  ActivityListResponse,
  ConvertToAccountInput,
  ConvertToAccountResponse,
  GenerateBorLetterResponse,
  OpportunityDetail,
} from "./types";


export function fetchOpportunityDetail(
  opportunity_id: string,
  opts?: { signal?: AbortSignal },
): Promise<OpportunityDetail> {
  return api.get<OpportunityDetail>(
    `/api/v1/sales/opportunities/${opportunity_id}`,
    opts,
  );
}


export function fetchOpportunityActivities(
  opportunity_id: string,
  opts?: { signal?: AbortSignal },
): Promise<ActivityListResponse> {
  const qs = new URLSearchParams({ opportunity_id }).toString();
  return api.get<ActivityListResponse>(
    `/api/v1/sales/activities?${qs}`,
    opts,
  );
}


export function generateBorLetter(
  opportunity_id: string,
): Promise<GenerateBorLetterResponse> {
  return api.post<GenerateBorLetterResponse>(
    `/api/v1/sales/opportunities/${opportunity_id}/generate-bor-letter`,
  );
}


// BE-SCRM-032 — convert a Closed Won opportunity to an Account.
export function convertOpportunityToAccount(
  opportunity_id: string,
  input: ConvertToAccountInput = {},
): Promise<ConvertToAccountResponse> {
  return api.post<ConvertToAccountResponse>(
    `/api/v1/sales/opportunities/${opportunity_id}/convert-to-account`,
    input,
  );
}
